import { BusinessRegion } from '../../configuration/configuration';
import { InternationalDiallingCodes, INTERNATIONAL_DIALLING_CODES } from '../internationalDiallingCodes';

export const getInternationalDiallingCode = (businessRegion: BusinessRegion, residenceOfCountry: string | undefined) =>
  businessRegion === BusinessRegion.AUS ? InternationalDiallingCodes.Australia : INTERNATIONAL_DIALLING_CODES[residenceOfCountry!];
